import { atom } from "jotai";

export enum GlobalNotificationTypes {
  info = "info",
  error = "error",
  success = "success",
  warning = "warning",
}

export type GlobalNotificationStateProps =
  | {
      open?: boolean;
      slug?: string;
      type?: GlobalNotificationTypes;
      linkCaption?: string;
      linkHref?: string;
      ctaCaption?: string;
      closeOnClickCta?: boolean;
      onClickCta?: () => void;
      title?: string;
      description?: string;
    }
  | undefined;

export const globalNotificationState = atom<GlobalNotificationStateProps>({});
